import React from 'react';
/**
 * We are still seeing unexpected token errors in jest tests which could be
 * due to @babel problems that haven't been resolved or implemented
 */
import { css } from '@compiled/react';

import Page16Icon from '@atlaskit/icon-object/glyph/page/16';
import { token } from '@atlaskit/tokens';

import { HeightAdjustedContainer } from './HeightAdjustedContainer.tsx';
import { HeightAdjustingText } from './HeightAdjustingText.tsx';
import { TruncatedTextCacheKeys } from './TaskRowsContext.tsx';

interface PageProps {
	taskId: string; // The ID with the associated task.
	page: string; // The name of the page for the given task.
	url?: string;
}

const containerStyles = css({
	width: 270,
	position: 'relative',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> span': {
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
		marginTop: 4,
	},
});

const textWrapperStyles = css({
	height: '100%',
	width: '100%',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	paddingLeft: 10,
	display: 'flex',
	alignItems: 'flex-start',
	color: token('color.text'),

	// line-height is 20px by default and the icon is 16px so
	marginTop: token('space.negative.025'),
});

export const PageColumn = ({ taskId, page, url }: PageProps) => {
	return (
		<HeightAdjustedContainer css={containerStyles} taskId={taskId}>
			<Page16Icon label="page title icon" />
			<div css={textWrapperStyles} data-testid="page-column">
				<HeightAdjustingText
					taskId={taskId}
					defaultText={page}
					cacheKey={TruncatedTextCacheKeys.PAGE}
					url={url}
				/>
			</div>
		</HeightAdjustedContainer>
	);
};
